import styled from "@emotion/styled";

export const DashDateTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: ${({ theme }) => theme.colors.main[9]};

  .date {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.main[9]};
  }

  .time {
    font-size: 1.8rem;
    opacity: 0.95;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.main[9]};
  }

  @media (max-width: 940px) {
    .date {
      font-size: 1.5rem;
    }
    .time {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 480px) {
    .date {
      font-size: 1.3rem;
    }
    .time {
      font-size: 1.3rem;
    }
  }
`;
